import { render, staticRenderFns } from "./PopupSignature.vue?vue&type=template&id=1174b44e"
import script from "./PopupSignature.vue?vue&type=script&lang=ts"
export * from "./PopupSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports